export default __webpack_public_path__ + "static/media/roboto-v20-latin-300.f1bae4d4.ttf";